export default __webpack_public_path__ + "static/media/txt3_sp.b7173242.png";